import { Button, Grid, Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { GetAllFormatos } from "../../../hooks/getAllFormatos";
import { TablaFormatos } from "./componentes/TablaFormatos";
import { useNavigate } from "react-router-dom";
import { CopiarFormato, DeleteFormato } from "../../../hooks/crearFormato";
import { useLoading } from "../../../components/Loading/useLoading";
import { useSnackbar } from "notistack";
import { DeleteItemFormato } from "../../../hooks/deleteItemFormato";
import { ModalNoDel } from "./componentes/modalNoDel";

export const EtiquetasIndex = () => {
  const { getAllFormatosMutation } = GetAllFormatos();
  const { copiarFormatoMutation } = CopiarFormato();
  const { deleteFormato } = DeleteFormato();
  const [sample, setSample] = useState([]);
  const [modalDel, setModalDel] = useState(false);
  const [partesDel, setPartesDel] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const get_data_tabla = () => {
    setAppLoading(true);
    getAllFormatosMutation("", {
      onSuccess: (data) => {
        console.log(data);
        setSample(data);
      },
      onError: (error) => {
        alert("Error al cargar los datos");
      },
      onSettled: () => {
        setAppLoading(false);
      },
    });
  };
  useEffect(() => {
    dispatch(HEADER_DATA_UPDATE({ nombreData: "" }));
    get_data_tabla();
  }, []);

  const copy = (id) => {
    setAppLoading(true);
    copiarFormatoMutation(id, {
      onSuccess: (data) => {
        enqueueSnackbar("Formato copiado exitosamente", {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
        get_data_tabla();
      },
      onError: (error) => {
        enqueueSnackbar("Error al copiar formato", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
      },
    });
  };
  const del = (id) => {
    setAppLoading(true);
    deleteFormato(id, {
      onSuccess: (data) => {
        if (!data?.success) {
          setModalDel(true);
          setPartesDel(data?.data);
        } else {
          enqueueSnackbar("Formato eliminado correctamente", {
            autoHideDuration: 2000,
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
        }
        get_data_tabla();
      },
      onError: (error) => {
        enqueueSnackbar("Error al eliminar formato", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
      },
    });
  };
  const handleClose = () => {
    setModalDel(false);
    setPartesDel([]);
  };

  return (
    <>
      <Grid container spacing={0} sx={{ height: 100 }}>
        <Grid
          item
          xs={3}
          sm={3}
          md={3}
          lg={2}
          xl={2}
          sx={{ padding: "10px 30px", height: "100%" }}
          className="center_item"
        >
          <Button
            variant="contained"
            className="btn_system"
            onClick={() => navigate("/inventarios/etiquetas/nuevo")}
          >
            Crear
          </Button>
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          sx={{ padding: "10px 20px", height: "100%" }}
          className="center_item"
        >
          <TablaFormatos
            key={"table_gen"}
            rows={sample}
            copy={copy}
            del={del}
          />
        </Grid>
      </Grid>
      <ModalNoDel
        key={"modal_no_del"}
        open={modalDel}
        handleClose={handleClose}
        items={partesDel}
      />
    </>
  );
};
